import axios from 'axios';

// Support both REACT_APP_API_URL (new) and REACT_APP_BACKEND_URL (legacy)
const BACKEND_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Services API
export const fetchServices = async () => {
  const response = await axios.get(`${API}/services`);
  return response.data.services;
};

// Portfolio API
export const fetchPortfolio = async () => {
  const response = await axios.get(`${API}/portfolio`);
  return response.data.projects;
};

// Testimonials API
export const fetchTestimonials = async () => {
  const response = await axios.get(`${API}/testimonials`);
  return response.data.testimonials;
};

// Contact API
export const submitContactForm = async (data) => {
  const response = await axios.post(`${API}/contact`, data);
  return response.data;
};

// Cart APIs
export const addToCart = async (sessionId, serviceId, quantity = 1, businessInfo = null) => {
  const payload = {
    session_id: sessionId,
    service_id: serviceId,
    quantity
  };
  
  // Include business info if provided
  if (businessInfo) {
    payload.business_info = {
      business_name: businessInfo.businessName,
      industry: businessInfo.industry,
      primary_goal: businessInfo.primaryGoal,
      current_tools: businessInfo.currentTools,
      target_audience: businessInfo.targetAudience,
      timeline: businessInfo.timeline,
      monthly_budget: businessInfo.monthlyBudget
    };
  }
  
  const response = await axios.post(`${API}/cart/add`, payload);
  return response.data;
};

export const getCart = async (sessionId) => {
  const response = await axios.get(`${API}/cart/${sessionId}`);
  return response.data.cart;
};

export const updateCartQuantity = async (sessionId, serviceId, quantity) => {
  const response = await axios.put(`${API}/cart/update`, {
    session_id: sessionId,
    service_id: serviceId,
    quantity
  });
  return response.data;
};

export const removeFromCart = async (sessionId, serviceId) => {
  const response = await axios.delete(`${API}/cart/remove/${sessionId}/${serviceId}`);
  return response.data;
};

// Checkout APIs
export const createStripeCheckoutSession = async (sessionId, customerInfo) => {
  const response = await axios.post(`${API}/checkout/stripe/create-session`, {
    session_id: sessionId,
    customer_info: customerInfo,
    payment_method: 'stripe'
  }, {
    headers: {
      'Origin': window.location.origin
    }
  });
  return response.data;
};

export const getStripeCheckoutStatus = async (stripeSessionId) => {
  const response = await axios.get(`${API}/checkout/stripe/status/${stripeSessionId}`);
  return response.data;
};

// Order API
export const getOrder = async (orderId) => {
  const response = await axios.get(`${API}/orders/${orderId}`);
  return response.data.order;
};
